import { createColumn, getSortOptions } from "@repo/mfe-core";
import type { IntlShape } from "react-intl";

export const tableColumns = [
  createColumn("usernameCell", "Username", "20rem", {
    isPinned: true,
    hasCheckbox: true,
  }),
  createColumn("firstname", "First Name", "10rem"),
  createColumn("lastname", "Last Name", "10rem"),
  createColumn("email", "Email", "20rem"),
  createColumn("managername", "Manager", "10rem"),
];

const sortableColumns = [
  "usernameCell",
  "firstname",
  "lastname",
  "email",
  "managername",
];

export const getSortConfigs = (intl: IntlShape) =>
  sortableColumns.map((key) => ({ key, sortOptions: getSortOptions(intl) }));
